import moment from 'moment';

export const BEAUTY_TIME = {
  methods: {
    mixinBeautyTime(time) {
      return moment.utc(time * 1000).format('HH:mm:ss');
    },
  },
};
